<div class="content-block">
  <div class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          <h2>Cronologia <b> Log Azioni </b></h2>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
            <li class="breadcrumb-item">Tabelle</li>
            <li class="breadcrumb-item active">Log Azioni</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header primary">
      <h3 class="card-title">
        <i class="fa fa-chart-pie mr-1"></i>
      </h3>
    </div>
    <!-- /.card-header -->
    <div class="filtro-grid">
      <div class="campo">
        <label>Da data</label>
        <dx-date-box type="date" [(value)]="daData" displayFormat="dd/MM/yyyy">
        </dx-date-box>
      </div>

      <div class="campo">
        <label>A data</label>
        <dx-date-box type="date" [(value)]="aData" displayFormat="dd/MM/yyyy">
        </dx-date-box>
      </div>
      <div class="campo campo-bottone">
        <dx-button
          stylingMode="contained"
          text="Cerca"
          icon="search"
          type="normal"
          (onClick)="cercaLog()"
        >
        </dx-button>
      </div>
    </div>
    <div class="card-body">
      <dx-data-grid
        [dataSource]="dataSource"
        [showBorders]="true"
        [focusedRowEnabled]="false"
        [focusedRowIndex]="0"
        [allowColumnResizing]="true"
        [columnAutoWidth]="true"
        [columnResizingMode]="columnResizingMode"
        [showColumnLines]="true"
        [showRowLines]="true"
        [rowAlternationEnabled]="true"
        [allowColumnReordering]="true"
        [wordWrapEnabled]="false"
        (onExporting)="onExporting($event)"
      >
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-paging [pageSize]="20"></dxo-paging>
        <dxo-pager
          [showPageSizeSelector]="true"
          [showInfo]="true"
          [allowedPageSizes]="[10, 20, 50, 100]"
        ></dxo-pager>
        <dxo-filter-row [visible]="false"></dxo-filter-row>
        <dxo-header-filter
          [visible]="true"
          [allowSearch]="true"
        ></dxo-header-filter>

        <dxo-editing
          mode="row"
          [allowAdding]="false"
          [allowUpdating]="false"
          [allowDeleting]="false"
          [useIcons]="true"
        ></dxo-editing>

        <dxi-column
          caption=""
          name="detailLog"
          [allowFiltering]="false"
          [allowSorting]="false"
          cellTemplate="showMoreTemplate"
          width="40"
          caption=""
          alignment="center"
        >
        </dxi-column>

        <div *dxTemplate="let d of 'showMoreTemplate'">
          <i
            class="fa fa-eye"
            (click)="showMoreDetail(d.data)"
            style="cursor: pointer"
            data-toggle="tooltip"
            data-placement="top"
            title="modifica"
          ></i>
        </div>

        <dxi-column
          dataField="logAzioni.idUtente"
          caption="id Utente"
        ></dxi-column>
        <dxi-column dataField="utente" caption="Utente"></dxi-column>
        <dxi-column
          dataField="logAzioni.tabella"
          caption="Tabella"
        ></dxi-column>
        <dxi-column
          dataField="logAzioni.chiaveTabella"
          caption="Chiave Tabella"
        ></dxi-column>

        <dxi-column
          dataField="logAzioni.dataOra"
          caption="Data"
          dataType="date"
          format="dd/MM/yyyy HH:mm:ss"
          [sortIndex]="1"
          sortOrder="desc"
        ></dxi-column>

        <dxi-column dataField="logAzioni.azione" caption="azione"></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>

@if (detailToShow) {
  <app-popup-dettaglio-log-azioni
    [rigaDettaglio]="detailToShow"
    (dettaglioLogAzioniPopupEventEmitter)="
      onPopupDettaglioLogAzioniEvent($event)
    "
  >
  </app-popup-dettaglio-log-azioni>
}
